import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=963c2cee&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TopNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports